const state = () => ({
  hasLoaded: false,
  simsLoaded: {},
});

const getters = {
  hasLoaded: state => state.hasLoaded,
  simsLoaded: state => state.simsLoaded,
};

const mutations = {
  setHasLoaded(state, hasLoaded) {
    state.hasLoaded = hasLoaded;
  },
  setSimsLoaded(state, categoryId) {
    state.simsLoaded[`${categoryId}`] = true;
  },
};

const actions = {
  setSimsLoaded({ commit }, simId) {
    commit('setHasLoaded', simId);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
